import { getWorkshopCategoriesV1, type WorkshopParameters } from '../../api/api'
import { WorkshopsGlobalListMVP } from '../../pages/WorkshopsGlobalListMVP'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/(app)/_app/workshops/$type')({
  component: WorkshopsGlobalListMVP,
  validateSearch: (search: Record<string, unknown>): WorkshopParameters => {
    // validate and parse the search params into a typed state
    return {
      page: Number(search?.['page'] ?? 1),
      // per_page: Number(search?.['per_page'] ?? 10),
      search: (search?.['search'] as string) || "",
      category: search?.['category'] as string,
      viewStatus: (search?.['viewStatus'] as "UPCOMING" | "RECORDED") || "UPCOMING"
    }
  },
  loader: async () => {
    const categories = await getWorkshopCategoriesV1()
    return {
      categories
    }
  }
})